import { useState } from 'react';

/** What the user has chosen for one schema's row. */
export type GroupChoice = {
  combine: boolean;
  auto: boolean;
  excluded: ReadonlySet<string>;
  labelColumn: string;
};

const DEFAULT_CHOICE: GroupChoice = {
  combine: true,
  auto: true,
  excluded: new Set(),
  labelColumn: '',
};

/**
 * Every schema's choices, kept above the rows so a row the search hides (and
 * so unmounts) keeps what the user chose when it is shown again.
 */
export function useGroupChoices() {
  const [byId, setById] = useState<Record<string, GroupChoice>>({});
  return {
    choiceOf: (schemaId: string) => byId[schemaId] ?? DEFAULT_CHOICE,
    choose: (schemaId: string, patch: Partial<GroupChoice>) =>
      setById((all) => ({
        ...all,
        [schemaId]: { ...(all[schemaId] ?? DEFAULT_CHOICE), ...patch },
      })),
  };
}
